var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('module',[_c('div',{staticClass:"guide-detail"},[_c('h1',{staticClass:"guide-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"guide-time"},[_vm._v("发布时间："+_vm._s(_vm.publish_time))]),_c('div',{staticClass:"guide-line"}),_c('div',{staticClass:"guide-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }